import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { ApplicationPayment } from '@/types/application-payment';

/**
 * Получает список заявок на оплату
 */
export async function getApplicationsPayments() {
	const token = cookies.get(TOKEN_COOKIE_NAME);

	const { data } = await axios.get<ApplicationPayment[]>(
		`${process.env.HOST}/api_v1/applications_payment/`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);

	return data;
}
